import { auth, fire } from "../../firebase/index";

const db = fire.database();

const getRecipientsCount = async (callback) => {
  const ufliArr = [];
  await db
    .ref("userFriendListIndustrial/" + auth.currentUser.uid)
    .once("value")
    .then((snapshot) => {
      if (snapshot.exists()) {
        const userDetailsInUFLI = snapshot.val();
        for (const eachUser in userDetailsInUFLI) {
          ufliArr.push(userDetailsInUFLI[eachUser].friendEmail);
        }
      }
    });

  callback(ufliArr.length + 1);
};

const getActiveRemoteCount = async (callback) => {
  db.ref("retractableSharingRegistry")
    .child(auth.currentUser.uid)
    .orderByKey()
    .once("value")
    .then((snapshot) => {
      let tempArray = [];
      snapshot.forEach((childSnap) => {
        const item = childSnap.val();
        if (item.allowAccess) {
          tempArray.push(item);
        }
      });

      callback(tempArray.length);
    });
};

const getLockCount = async (callback) => {
  db.ref("userLocks")
    .child(auth.currentUser.uid)
    .orderByKey()
    .once("value")
    .then((snapshot) => {
      var tempArray = [];

      tempArray = snapshotToArray(snapshot);
      callback(tempArray.length);
    });
};

const snapshotToArray = (snapshot) => {
  var returnArr = [];
  snapshot.forEach(function(childSnapshot) {
    var item = childSnapshot.val();
    item.key = childSnapshot.key;
    returnArr.push(item);
  });
  return returnArr;
};

export { getRecipientsCount, getActiveRemoteCount, getLockCount };
